import { render, staticRenderFns } from "./UsersTablePage.vue?vue&type=template&id=0ebda4e2"
import script from "./UsersTablePage.vue?vue&type=script&lang=js"
export * from "./UsersTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports